import React, { useMemo } from 'react';
import { GroupBase } from 'react-select';
import { IOptionBase, ISelectMenuPortalProps } from '../models';
import { getExtraStyles } from '@src/atoms/Select/utils';

export const SelectMenu = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>({
  children,
  innerProps,
  ...props
}: React.PropsWithChildren<ISelectMenuPortalProps<OptionType, IsMulti, GroupType>>) => {
  const extraStyles = useMemo(() => getExtraStyles(props?.selectProps?.styles?.menu), [props.selectProps]);

  return (
    <div {...innerProps} data-elem="select-menu" style={extraStyles}>
      {children}
    </div>
  );
};
